namespace Matrix.Administration {
    export class RoleColumns {
        static columnsKey = 'Administration.Role';
    }
}
